// import React, { useRef } from "react";
// import { Button, DatePicker, Form, Select } from "antd";
// import moment from "moment";
// import { Col, Container, Row } from "react-bootstrap";
// import { BsSearch } from "react-icons/bs";

// function MenuBarSales(props) {
//   const formRef = useRef();
//   const { RangePicker } = DatePicker;

//   const defaultDate = moment();

//   const onFinish = (values) => {
//     const dateRange = values?.dateRange;
//     const requestObj = {
//       user_ids: values?.search ? values.search : [],
//       dateFrom: dateRange
//         ? moment(dateRange[0]).format("YYYY-MM-DD")
//         : moment().format("YYYY-MM-DD"),
//       dateTo: dateRange
//         ? moment(dateRange[1]).format("YYYY-MM-DD")
//         : moment().format("YYYY-MM-DD"),
//     };
//     props.onFinish(requestObj);
//   };

//   const handleOnchange = (val) => {
//     props?.handleOnchange(val);
//   };
//   console.log("props?.allUsers --->>");
//   console.log(props?.allUsers);
//   console.log("props?.allUsers --->>");

//   return (
//     <Container fluid>
//       <Form
//         ref={formRef}
//         onFinish={onFinish}
//         initialValues={{
//           dateRange: [defaultDate, defaultDate],
//           search: [],
//         }}
//       >
//         <Row>
//           <Col md={3}>
//             <Form.Item name="dateRange">
//               <RangePicker
//                 className="w-100"
//                 format="YYYY-MM-DD"
//                 defaultValue={[defaultDate, defaultDate]}
//               />
//             </Form.Item>
//           </Col>
//           <Col>
//             <Form.Item name="search">
//               <Select
//                 mode="multiple"
//                 className="borderedSelect w-100"
//                 bordered={false}
//                 onChange={(val) => handleOnchange(val)}
//                 allowClear
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//                 options={props?.allUsers?.map((item) => ({
//                   value: item?.id.toString(),
//                   label: item?.name,
//                 }))}
//                 placeholder="Search by name (select multiple)..."
//                 showSearch
//               />
//             </Form.Item>
//           </Col>
//           <Col />
//           <Col className="d-flex justify-content-end">
//             <Button type="primary" className="w-50" htmlType="submit">
//               <div className="Reports-MenuBar-btn">
//                 Filter <BsSearch />
//               </div>
//             </Button>
//           </Col>
//         </Row>
//       </Form>
//     </Container>
//   );
// }

// export default MenuBarSales;
import React, { useRef } from "react";
import { Button, DatePicker, Form, Select } from "antd";
import moment from "moment";
import { Col, Container, Row } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";

function MenuBarSales(props) {
  const formRef = useRef();
  const { RangePicker } = DatePicker;

  const defaultDate = moment();

  const onFinish = (values) => {
    const dateRange = values?.dateRange;
    const requestObj = {
      user_ids: values?.search ? values.search : [],
      dateFrom: dateRange
        ? moment(dateRange[0]).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
      dateTo: dateRange
        ? moment(dateRange[1]).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
    };
    props.onFinish(requestObj);
  };

  const handleOnchange = (val) => {
    props?.handleOnchange(val);
  };

  return (
    <Container fluid>
      <Form
        ref={formRef}
        onFinish={onFinish}
        initialValues={{
          dateRange: [defaultDate, defaultDate],
          search: [],
        }}
      >
        <Row>
          <Col md={3}>
            <Form.Item name="dateRange">
              <RangePicker
                className="w-100"
                format="YYYY-MM-DD"
                defaultValue={[defaultDate, defaultDate]}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="search">
              <Select
                mode="multiple"
                className="borderedSelect w-100"
                bordered={false}
                onChange={(val) => handleOnchange(val)}
                allowClear
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={props?.allUsers?.map((item) => ({
                  value: item?.id.toString(),
                  label: item?.account_no?.[0]
                    ? `${item?.name} (${item?.account_no[0]})`
                    : item?.name,
                }))}
                placeholder="Search by name or account number (select multiple)..."
                showSearch
              />
            </Form.Item>
          </Col>
          <Col />
          <Col className="d-flex justify-content-end">
            <Button type="primary" className="w-50" htmlType="submit">
              <div className="Reports-MenuBar-btn">
                Filter <BsSearch />
              </div>
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default MenuBarSales;
